module.exports = __webpack_public_path__ + "img/circle.27611008.png";